import React, { useState } from "react";

const plans = [
    { name: "Basic", price: "$10/year" },
    { name: "Advanced", price: "$15/year" },
    { name: "Community", price: "$35/year" },
    { name: "Enterprise", price: "Custom Pricing" }
];

const BillingSetup = ({ formData }) => {
    const [selectedPlan, setSelectedPlan] = useState(formData.selectedPlan || "");

    return (
        <div className="form-container">
            <h2>Select a Plan</h2>
            <div className="plan-list">
                {plans.map((plan, index) => (
                    <div
                        key={index}
                        className={`plan-card ${selectedPlan === plan.name ? "selected" : ""}`}
                        onClick={() => setSelectedPlan(plan.name)}
                    >
                        <h3>{plan.name}</h3>
                        <p>{plan.price}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BillingSetup;
